import ActionCompletePage, { ActionCompletePageProps } from './ActionCompletePage';

export type { ActionCompletePageProps };
export default ActionCompletePage;
